import {Component, OnDestroy, QueryList, ViewChildren} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IonSearchbar, LoadingController, ModalController, ToastController} from '@ionic/angular';
import {Subject} from 'rxjs';
import {BaseClass} from 'src/app/shared/classes/base';
import {AttributeType} from 'src/app/shared/modals/filters/models/filter-models';
import {ProcessConfig} from '../../shared/interfaces/process-config.interface';
import {ProcessStatusEnum} from '../../shared/interfaces/process.interface';
import {TranslationService} from '../../shared/services/translation.service';
import {Evaluation360Service} from '../360-evaluation.service';
import {Evaluated360User} from '../_interfaces/360-evaluation-user.interface';
import {AreaConfig} from '../_interfaces/area-config.interface';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-360-evaluation-selection',
    templateUrl: './evaluation-selection.page.html',
    styleUrls: ['./evaluation-selection.page.scss', '../360-evaluation.page.scss']
})
export class Evaluation360SelectionPage extends BaseClass implements OnDestroy {

    @ViewChildren('userSearchSame') userSearchSame: QueryList<IonSearchbar>;
    public hideAttributesFromUserSearchOn360: boolean;
    public showSelectedCountOnSelection360: boolean;

    public processConfig: ProcessConfig;
    public status: ProcessStatusEnum;
    public areas: Array<AreaConfig> = [];

    public stringToSearch: string;
    public areaIndexToSearch: number;
    public sendEvalForThreeSixtyClosed: boolean = false;
    public users: Array<Array<Evaluated360User>> = [];
    public selectedUsers: Array<Array<Evaluated360User>> = [];

    private _cycleId: number;
    private _cycleParticipantId: number;
    private _searchingAreaIndex: number;
    private _searchSubject: Subject<string> = new Subject();

    private showThreeSixtyEvaluationLimit: boolean;
    public aboveSelectionLimitMessage: string = "Selecionado por {{evaluationLimit}}+ usuários";

    constructor(
        protected _toastController: ToastController,
        protected _loadingController: LoadingController,
        protected _translationService: TranslationService,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _evaluationService: Evaluation360Service,
        private _modalController: ModalController,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
        // this._setSearchSubscriptions();
        this._cycleId = parseInt(
            this._activatedRoute.snapshot.paramMap.get('cycleId'), 10
        );

        this.hideAttributesFromUserSearchOn360 = this._configService.settings.features.hideAttributesFromUserSearchOn360;
        this.showSelectedCountOnSelection360 = this._configService.settings.features.showSelectedCountOnSelection360;
        this.showThreeSixtyEvaluationLimit = this._configService.settings.features.showThreeSixtyEvaluationLimit;
    }

    ionViewWillEnter() {
        this._evaluationService.getUser360Evaluators(
            this._cycleId
        ).subscribe((response) => {
            this._cycleParticipantId = response.data.cycleParticipantId;
            this.processConfig = response.data.config;
            this.status = response.data.status;
            this.areas = response.data.config.areas;
            this.sendEvalForThreeSixtyClosed =
                response.data.sendEvalForThreeSixtyClosed ? response.data.sendEvalForThreeSixtyClosed : false;
            if (response.data.evaluators)
                this._fillSelectedUsers(response.data.evaluators);

        }, (error) => this.notifyError(error));
    }

    public goBack(): void {
        this._router.navigate(['dashboard']);
    }

    public updateSearch(searchTextValue: string, areaIndex: number): void {
        this.stringToSearch = searchTextValue;
        this.areaIndexToSearch = areaIndex;
        this._searchingAreaIndex = areaIndex;
        this._searchSubject.next(searchTextValue);
    }

    public async selectUser(user: Evaluated360User, areaIndex: number): Promise<void> {
        
        const userFlags = user.flags;
        const errorMessages: string[] = [];

        const errorTranslations = {
            'Cycles.UserNotInCycle': 'Cycles.UserNotInCycle',
            'generic.InaccessibleUserByChineseWall': 'generic.InaccessibleUserByChineseWall',
            '360evaluation.unavailableManager': '360evaluation.unavailableManager',
            '360evaluation.doesNotHaveAttribute': '360evaluation.doesNotHaveAttribute',
            '360evaluation.360Finished': '360evaluation.evaluatorHas360StepClosed',
            '360evaluation.subordinate': '360evaluation.subordinate',
            'generic.directSubordinates': 'generic.directSubordinates'
        };

        for (const flag of userFlags) {
            if (errorTranslations[flag]) {
                let errorMessage = this._translationService.getTranslation(errorTranslations[flag]);
                
                if(flag === '360evaluation.360Finished' && this.sendEvalForThreeSixtyClosed)
                    continue; 

                if (flag === '360evaluation.360Finished' && !this.sendEvalForThreeSixtyClosed) {
                    errorMessage = errorMessage.replace('USER ', user.name);
                }

                errorMessages.push(errorMessage);
            }
        }

        if (errorMessages.length > 0) {
            const combinedErrorMessage = errorMessages.join('\n');
            this.notify(combinedErrorMessage, 'danger');
            return;
        }

        if (!this.selectedUsers[areaIndex]) {
            this.selectedUsers[areaIndex] = [];
        }

        if (user.aboveSelectionLimit) { 
            let message = this._translationService.getTranslation('360evaluation.selectionPage.confirm.message');
            message = message.replace('{{userName}}', user.name);
            message = message.replace('{{evaluationLimit}}', `${this.processConfig.threeSixtyEvaluationLimit || 1}`);

            await this.createConfirmModal(message,()=>{
                this.addUserToList(user, areaIndex);
            });
         }else{
            this.addUserToList(user, areaIndex);
         }

        

        this.users[areaIndex] = [];
        this.userSearchSame.forEach(i => i.value = '');
    }

    private addUserToList(user: Evaluated360User, areaIndex: number){
        if (!this.selectedUsers[areaIndex].some(u => u.userId === user.userId)) {
            user.areaId = this.areas[areaIndex].areaId;
            this.selectedUsers[areaIndex].push(user);
        }
    }

    private async createConfirmModal(message:string,callback: Function) {
        console.log('create confirm modal');
        
        const modalConfirm = await this._modalController.create({
            component: ConfirmModalComponent,
            cssClass: 'confirm-modal',
            componentProps: {
                title: '',
                message: message,
                btnConfirmText: this._translationService.getTranslation('360evaluation.evaluatorsLimit.continue'),
            }
        });

        await modalConfirm.present();

        modalConfirm.onDidDismiss()
            .then((event) => {
                if (event.data) {
                    callback();
                }
            });
    }


    public removeUser(areaIndex: number, userIndex: number): void {
        this.selectedUsers[areaIndex].splice(userIndex, 1);
    }

    public async save(): Promise<void> {
        const error = this._validateSelection(this.selectedUsers, this.areas);
        if (error) {
            if (error.area) {
                let errorMessage = this._translationService.getTranslation(error.message) + ' '
                    + this._translationService.getTranslation('generic.of') + ' '
                    + error.area + ': '
                    + error.value;
                await this.notify(errorMessage, 'danger', 5000);
            } else
                await this.notify(this._translationService.getTranslation(error.message) + ': ' + error.value, 'danger', 5000);
        } else {
            const loading = await this._loadingController.create();
            await loading.present();

            this._evaluationService.saveUsersFor360Evaluation(
                this._cycleParticipantId,
                this._cycleId,
                [].concat.apply([], this.selectedUsers)
            ).subscribe(() => {
                loading.dismiss();
                this.notifySuccess('generic.saveSuccess');
                this.goBack();
            }, (error) => {
                let errors = error.error.errors;
                if (errors && errors.length > 0) {
                    if (errors[0].includes('{')) {
                        try {
                            let errorResponse = JSON.parse(errors[0]);
                            let errorMessage = errorResponse.MessageOrNames;
                            loading.dismiss();
                            this.notify(this._translationService.getTranslation('360Evaluation.cannotAccessNamesByWallChinese') + ' ' + errorMessage, 'danger');
                        } catch (e) {
                            this.getErrorNotification(e);
                            loading.dismiss();
                            throw (e);
                        }
                        loading.dismiss();
                        return;
                    }
                    if (errors[0] === '360Evaluation.moreThanThreeNotAccessibleUsersByChineseWall') {
                        this.notify(errors[0], 'danger');
                        loading.dismiss();
                        return;
                    }
                    if (errors[0].includes('/')) {
                        const splitted = errors[0].split('/');
                        const translated = this._translationService.getTranslation(splitted[0]);
                        const re = /USER/gi;
                        this.notify(translated.replace(re, splitted[1]), 'danger');
                        loading.dismiss();
                        return;
                    }
                }
                loading.dismiss();
                this.notifyError(error);
            });
        }
    }

    public loadUsers(areaIndex: number, searchComponent: IonSearchbar) {
        const searchString = searchComponent.value || '';
        const area = this.areas[areaIndex];
        let areaId = this.areas.some(area => area.userAttributesType && area.userAttributesType.length > 0) ? area.areaId : 0;
        this._evaluationService.getUsersFor360Evaluation(
            this._cycleId, searchString, null, area.attributeType, area.attributeAction, areaId
        ).subscribe((response) => {
            this.users[areaIndex] = response.data;

            if(this.showThreeSixtyEvaluationLimit && this.processConfig.enableValuationLimit)
                this.handleThreeSixtyEvaluationLimitForUsers(areaIndex);
            else console.log('ThreeSixtyEvaluationLimit is disabled');
            
        }, (error) => this.notifyError(error));
    }

    private handleThreeSixtyEvaluationLimitForUsers(areaIndex: number){
        this.users[areaIndex].forEach((user) => {
            if(user.selectedCount >= (this.processConfig.threeSixtyEvaluationLimit || 1))
                user.aboveSelectionLimit = true;
        });

        this.aboveSelectionLimitMessage = this._translationService
            .getTranslation('360evaluation.selectionPage.aboveSelectionLimit.message')
            .replace('{{evaluationLimit}}', `${this.processConfig.threeSixtyEvaluationLimit || 1}`);
    }

    private _fillSelectedUsers(evaluators: Array<Evaluated360User>): void {
        this.selectedUsers = [];

        if (this.processConfig.areas) {
            for (let i = 0; i < this.processConfig.areas.length; i++) {
                this.selectedUsers[i] = [];
            }
        }

        evaluators.forEach((evaluator: Evaluated360User) => {
            const areaIndex = this.areas.findIndex(a => a.areaId === evaluator.areaId);
            if (areaIndex >= 0)
                this.selectedUsers[areaIndex].push(evaluator);
        });
    }

    private _validateSelection(
        selectedUsers: Array<Array<Evaluated360User>>, areas: Array<AreaConfig>
    ): { area: string | null; message: string; value: number; areaLenghtError: boolean } {
        let totalUsers = 0;
        let minEvaluators = 0;
        let maxEvaluators = 0;
        for (const element of areas) {
            minEvaluators += element.minEvaluators;
            maxEvaluators += element.maxEvaluators;
        }
        for (const element of selectedUsers) {
            const users = element;

            if (users.length === 0) {
                continue;
            }

            totalUsers += users.length;

            const areaIndex = areas.findIndex(a =>
                a.areaId === element[0].areaId
            );

            if (!areas[areaIndex].requiresEvaluatorsValidation)
                continue;

            if (users.length < areas[areaIndex].minEvaluators)
                return {
                    areaLenghtError: true,
                    message: '360evaluation.minEvaluatorsRequired',
                    area: areas[areaIndex].globalizationConfig[this.getSelectedLanguage()].title,
                    value: areas[areaIndex].minEvaluators
                };

            if (users.length > areas[areaIndex].maxEvaluators)
                return {
                    areaLenghtError: true,
                    message: '360evaluation.evaluatorsLimitReached',
                    area: areas[areaIndex].globalizationConfig[this.getSelectedLanguage()].title,
                    value: areas[areaIndex].maxEvaluators
                };
        }

        if (totalUsers < minEvaluators)
            return {
                areaLenghtError: false,
                message: '360evaluation.minEvaluatorsRequired',
                area: null,
                value: minEvaluators
            };

        if (totalUsers > maxEvaluators)
            return {
                areaLenghtError: false,
                message: '360evaluation.evaluatorsLimitReached',
                area: null,
                value: maxEvaluators
            };

        return null;
    }

    public returnAttributeType(areaIndex) {
        return AttributeType[this.areas[areaIndex].attributeType];
    }

    ngOnDestroy() {
        this._searchSubject.unsubscribe();
    }

}
